export enum PatientInteractionLocationEligibilityStatus {
  new = 'new',
  eligible = 'eligible',
  ineligible = 'ineligible',
}
